export default __webpack_public_path__ + "static/media/Dashboard.b7d2a9e5.svg";